<template>
  <div>
  <el-image
      style="width: 20px; height: 20px;"
      :preview-teleported="true"
      :src="nowImgUrl"
      :preview-src-list="[nowImgUrl]"
      :initial-index="4"
      fit="cover"
      :teleported="true"
  >
    <template #error>
      <div class="image-slot">
        <el-icon><icon-picture /></el-icon>
      </div>
    </template>
  </el-image>
</div>
</template>

<script>
import { Picture as IconPicture } from '@element-plus/icons-vue'
import {getFileUrl} from "@/request/BasicDataApi";
export default {
  name: "index",
  components:{IconPicture},
  props: ['imgUrl'],
  data() {
    return {
      open: false,
      nowImgUrl:'',
    }
  },
  created() {
    },
  methods: {},
  watch:{
    'imgUrl':{
      immediate:true,
      handler: function (val) {
        if(val == null) {
          this.nowImgUrl = ""
          return
        }
        getFileUrl({url: val}).then((res) => {
          if (res.code == 0) {
            let imgUrl = res.data;
            this.nowImgUrl = imgUrl
          }
        })
      }
    }
  }

}
</script>

<style scoped>

</style>
